import { Reveal } from './Reveal';

const LOGOS = [
  '/landing/logo-strip-1.png',
  '/landing/logo-strip-2.png',
  '/landing/logo-strip-3.png',
  '/landing/logo-strip-4.png',
  '/landing/logo-strip-5.png',
  '/landing/logo-strip-7.png',
];

export function TrustedBySection() {
  return (
    <section style={{ maxWidth: 1400, margin: '0 auto', padding: '0 24px 40px' }}>
      <Reveal scale={0.96} y={20}>
        <div style={{ background: '#f9f9fb', borderRadius: 19, padding: '32px 40px' }}>
          <p style={{ margin: '0 0 28px', textAlign: 'center', fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: 14, color: '#4a4e68' }}>
            Trusted by forward-thinking businesses
          </p>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 48, flexWrap: 'wrap' }}>
            {LOGOS.map((src, i) => (
              <Reveal key={src} delay={i * 0.3} y={0} x={i % 2 === 0 ? -30 : 30}>
                <img
                  src={src}
                  alt="Partner logo"
                  width={140}
                  height={45}
                  style={{ objectFit: 'contain', height: 36, width: 'auto', filter: 'grayscale(1)', opacity: 0.65 }}
                />
              </Reveal>
            ))}
          </div>
        </div>
      </Reveal>
    </section>
  );
}
